import { createRestApiClient } from '..';

export const sendSms = (data) => {
  const restApiClient = createRestApiClient();
  let apiUrl = 'api/sendSMS';
  return restApiClient
    .request({
      method: 'POST',
      url: apiUrl,
      data: data,
    })
    .then((res) => res.data);
};

export const verifyLoginData = (data) => {
  const restApiClient = createRestApiClient(true);
  let apiUrl = 'api/webMobileLogin';
  return restApiClient
    .request({
      method: 'GET',
      url: apiUrl,
      params: data,
    })
    .then((res) => res.data);
};
